import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

const LanguageToggle = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ko' ? 'en' : 'ko';
    i18n.changeLanguage(newLang);
  };

  const getDisplayText = () => {
    return i18n.language === 'ko' ? 'English' : '한국어';
  };

  return (
    <button
      onClick={toggleLanguage}
      className="language-toggle"
      title={`Switch to ${getDisplayText()}`}
    >
      <FontAwesomeIcon icon={faGlobe} />
      <span>{getDisplayText()}</span>
    </button>
  );
};

export default LanguageToggle;
